"use strict";

import angular from "angular";
import template from "./scenario-toolbar.component.html";
import "./themes/scenario-toolbar.component.scss";
import "./themes/scenario-toolbar-dark.component.scss";
import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";
import { PublicCompany } from "../../../presentation/services/PublicCompany/PublicCompany";

class ScenarioToolbarComponent {
    togglePopOverPeriod = false;

    constructor($state) {
        this.$state = $state;
    }

    $onInit() {
        const companyId = this.$state.params.id;
        this.hasPermissionCompanyModel = PublicCompany.hasPermissionModelToModify(
            companyId,
            new UserDataAdapter().user()
        );
    }

    removeScenario(ev, scenarioId) {
        this.onRemoveScenario({ ev, scenarioId });
    }

    renameScenario(ev, scenario) {
        this.onRenameScenario({ ev, scenario });
    }

    isDisabledToEdit() {
        return this.current.scenario?.options?.editMode === false;
    }
}

ScenarioToolbarComponent.$inject = ["$state"];

export { ScenarioToolbarComponent };

const name = "scenarioToolbarComponent";
const def = {
    bindings: {
        loadingInit: "<",
        current: "<",
        message: "<",
        onYearChange: "&",
        onCancelChanges: "&",
        onSaveChanges: "&",
        onCreateProjection: "&",
        onSelectProjection: "&",
        projectionRemove: "&",
        onScenarioChange: "&",
        onRemoveScenario: "&",
        onRenameScenario: "&",
        titleButtonProjection: "@"
    },
    controller: ScenarioToolbarComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
